import React from "react";
import { useLanguage } from "../../../../contexts";
import { ASPECT_COLOR, mixHex } from "./visualColors";
import { formatShortDate, fracFecha, GridYears, YearAxis } from "./roadmapHelpers";

const LABEL_WIDTH = 214;

// Mapa de ruta en formato Gantt: una fila por objetivo (♦ en su año meta) +
// una fila por cada una de sus metas (barra fechaInicio→fechaFin). Puerto de
// renderRoadGantt() del mockup de referencia.
export function RoadmapGantt({ groups, baseYear, horizonEnd }) {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const horizon = horizonEnd - baseYear;

  return (
    <div style={{ maxWidth: 860, margin: "0 auto" }}>
      <YearAxis baseYear={baseYear} horizon={horizon} margin={LABEL_WIDTH} />
      {groups.map(({ aspect, objetivos }) => {
        const color = ASPECT_COLOR[aspect] || "#5E89B4";
        return (
          <React.Fragment key={aspect}>
            {objetivos.map((o) => {
              const metaPos = Math.min(fracFecha(`${o.year}-12-31`, baseYear, horizonEnd) * 100, 98.4).toFixed(1);
              return (
                <React.Fragment key={o._id}>
                  <div style={{ display: "flex", alignItems: "center", marginTop: 9 }}>
                    <div style={{ width: LABEL_WIDTH, paddingRight: 10, fontFamily: "'Sora',sans-serif", fontSize: 11, fontWeight: 700, color }}>
                      {o.code} · {t(o.action)} {o.source} −{o.reductionTons}%
                    </div>
                    <div style={{ flex: 1, position: "relative", height: 16, background: "#F6F9FC", borderRadius: 4 }}>
                      <GridYears horizon={horizon} />
                      <div
                        title={`${t("pd_gantt_meta_year_title")}: ${o.year}`}
                        style={{ position: "absolute", left: `${metaPos}%`, top: 1, transform: "translateX(-50%) rotate(45deg)", width: 11, height: 11, background: color, border: "2px solid #fff" }}
                      />
                    </div>
                  </div>
                  {(o.metas || []).map((m) => {
                    const x0 = fracFecha(m.fechaInicio, baseYear, horizonEnd) * 100;
                    const x1 = Math.max(fracFecha(m.fechaFin, baseYear, horizonEnd) * 100, x0 + 1.2);
                    return (
                      <div key={m._id} style={{ display: "flex", alignItems: "center", marginTop: 3 }}>
                        <div style={{ width: LABEL_WIDTH, paddingRight: 10, fontSize: 10.5, color: "#1A3562", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                          <strong>{m.code}</strong> {m.description}
                        </div>
                        <div style={{ flex: 1, position: "relative", height: 13 }}>
                          <GridYears horizon={horizon} />
                          <div
                            title={`${m.description} · ${formatShortDate(m.fechaInicio)} → ${formatShortDate(m.fechaFin)} · ${m.frecuencia}`}
                            style={{ position: "absolute", left: `${x0.toFixed(1)}%`, width: `${(x1 - x0).toFixed(1)}%`, top: 2, bottom: 2, background: mixHex(color, 0.35), borderRadius: 5, borderLeft: `3px solid ${color}` }}
                          />
                        </div>
                      </div>
                    );
                  })}
                </React.Fragment>
              );
            })}
          </React.Fragment>
        );
      })}
    </div>
  );
}
